import { Typography } from "antd";
import type { ReactNode } from "react";

const { Title, Text } = Typography;

interface PageHeaderProps {
	/** Page title text. */
	title: ReactNode;
	/** Optional subtitle / description shown under the title. */
	subtitle?: ReactNode;
	/** Right-aligned action slot (e.g. a "Qo'shish" button). */
	action?: ReactNode;
	/** AntD Title level (default 4). */
	level?: 1 | 2 | 3 | 4 | 5;
	className?: string;
}

/**
 * Standard page header: title (+ optional subtitle) on the left, action slot on the right.
 * Replaces the per-module `flex items-center justify-between` + `<Title>` + button pattern.
 */
export function PageHeader({ title, subtitle, action, level = 4, className }: PageHeaderProps) {
	return (
		<div
			className={`flex justify-between gap-4 mb-4 ${subtitle ? "items-start" : "items-center"} ${className ?? ""}`}
		>
			<div className="min-w-0">
				<Title level={level} className="mt-0! mb-0!">
					{title}
				</Title>
				{subtitle ? (
					<Text type="secondary" className="block mt-1">
						{subtitle}
					</Text>
				) : null}
			</div>
			{action ? <div className="shrink-0">{action}</div> : null}
		</div>
	);
}
